import { Table, TableProps } from 'antd';
import React from 'react';

interface IProps extends TableProps<any> {
  columns: Array<any>;
  data: Array<any>;
  minHeight: string;
  maxHeight: string;
  updateColumns: (e: any) => void;
  rowIndex?: number;
  changeRowIndex?: (rowIndex: number) => void; // 行を選択する
  doubleClickCustom?: (data: any) => void;
}

class TableComponent extends React.Component<IProps> {
  render() {
    const {
      columns,
      data,
      minHeight,
      maxHeight,
      updateColumns,
      rowIndex,
      changeRowIndex,
      doubleClickCustom,
      ...props
    } = this.props;

    let rowSelect = (e: any, idx: any) => {
      if (changeRowIndex !== undefined) {
        changeRowIndex(idx);
      }
    };
    return (
      <>
        <div className={`result-table ${data.length === 0 ? 'no-data' : ''}`}>
          <Table
            style={{ minHeight: minHeight, maxHeight: maxHeight }}
            size="small"
            rowClassName={(record, index) =>
              index % 2 === 0 ? 'table-row-light' : 'table-row-dark'
            }
            locale={{ emptyText: ' ' }}
            columns={columns}
            bordered={true}
            sticky={false}
            dataSource={data}
            pagination={false}
            onRow={(record, rowIndex) => {
              return {
                onDoubleClick: (event) => {
                  rowSelect(record, rowIndex);
                  if (doubleClickCustom) {
                    doubleClickCustom(record);
                  }
                },
              };
            }}
            {...props}
          />
        </div>
      </>
    );
  }
}

export default TableComponent;
